var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.lazyList, {
    tag: "component",
    attrs: {
      "pageCount": _vm.pageCount,
      "filter": _vm.filter,
      "products": _vm.products
    },
    on: {
      "input": _vm.search
    },
    scopedSlots: _vm._u([{
      key: "list-item",
      fn: function fn(_ref) {
        var product = _ref.product;
        return [_c(_vm.lazyListItem, {
          tag: "component",
          attrs: {
            "product": product
          }
        })];
      }
    }]),
    model: {
      value: _vm.page,
      callback: function callback($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  });
}
var staticRenderFns = []

export { render, staticRenderFns }